import React from 'react';

import { StudentClusterManager } from './components';

const StudentClusterCreate = () => {
  return <StudentClusterManager />;
};

export default StudentClusterCreate;
